import {styled} from '@mui/material/styles';
import {COLORS, SIZES, Typography} from '@fupa/fupa-uikit';

interface CardProps {
  cardStyle?: boolean;
  align?: string;
}

interface SectionProps {
  backgroundColor?: string;
  primaryGradient?: boolean;
}

const HIGHLIGHT_COLOR = '#00518f';

const Section = styled('section')<SectionProps>`
  background-color: ${(props) => (props.backgroundColor ? props.backgroundColor : COLORS.white)};
  width: 100%;
  display: flex;
  justify-content: center;
  padding: ${SIZES['48']} 0;
  ${(props) =>
    props.primaryGradient &&
    `
    background: radial-gradient(
    circle farthest-corner at center center,
    ${HIGHLIGHT_COLOR} 0%,
    ${COLORS.fupaPrimary} 60%
  );
  background: -webkit-radial-gradient(
    circle farthest-corner at center center,
    ${HIGHLIGHT_COLOR} 0%,
    ${COLORS.fupaPrimary} 60%
  );
  background: -moz-radial-gradient(
    circle farthest-corner at center center,
    ${HIGHLIGHT_COLOR} 0%,
    ${COLORS.fupaPrimary} 60%
  );`}
`;

const Card = styled('article')<CardProps>`
  display: flex;
  flex-direction: column;
  align-items: ${(props) => (props.align ? props.align : 'center')};
  width: 100%;
  max-width: 970px;
  padding: ${SIZES['16']} ${SIZES['32']};
  ${(props) =>
    props.cardStyle &&
    `
    background-color: ${COLORS.white};
    border-radius: ${SIZES['4']};
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.05);
    `}
`;

const CenteredTypography: any = styled(Typography)<{color: string}>`
  text-align: center;
  color: ${(props) => props.color};
`;

const ColoredTypography: any = styled(Typography)<{color: string}>`
  color: ${(props) => props.color};
`;

export {Card, CenteredTypography, ColoredTypography, Section};
